import styled from 'styled-components';
import SelectSite from '../../../../components/UI/selectSite';

const Wrapper = styled.div``;

const InviteButtonBlock = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 10px;
`;

const SelectSiteStyle = styled(SelectSite)`
  max-width: 338px;
`;

export { Wrapper, InviteButtonBlock, SelectSiteStyle};
